module.exports = __webpack_public_path__ + "produce-fresh-grass-11.jpg?4cafdec67daad001f720bbbb72ed9a03";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produce-fresh-grass-11.jpg
// module id = 48
// module chunks = 0